module.exports = __webpack_public_path__ + "static/media/officeActive.36e32a56.svg";